import React from 'react';
import { ArrowUpIcon, ArrowDownIcon } from 'lucide-react';
interface KPICardProps {
  title: string;
  value: string;
  change: number;
  icon: React.ReactNode;
  prefix?: string;
  suffix?: string;
}
const KPICard: React.FC<KPICardProps> = ({
  title,
  value,
  change,
  icon,
  prefix = '',
  suffix = ''
}) => {
  const isPositive = change >= 0;
  const changeColor = isPositive ? 'text-green-600' : 'text-red-600';
  const changeIcon = isPositive ? <ArrowUpIcon size={16} data-id="element-61" /> : <ArrowDownIcon size={16} data-id="element-62" />;
  return <div className="bg-white p-4 rounded-xl border border-gray-200 shadow-sm hover:shadow-md transition-shadow" data-id="element-63">
      <div className="flex justify-between items-start" data-id="element-64">
        <div data-id="element-65">
          <h3 className="text-sm font-medium text-gray-500" data-id="element-66">{title}</h3>
          <p className="text-2xl font-bold mt-1" data-id="element-67">
            {prefix}
            {value}
            {suffix}
          </p>
        </div>
        <div className="p-2 rounded-lg bg-blue-50 text-blue-600" data-id="element-68">{icon}</div>
      </div>
      <div className="mt-4 flex items-center" data-id="element-69">
        <div className={`flex items-center ${changeColor}`} data-id="element-70">
          {changeIcon}
          <span className="text-sm font-medium ml-1" data-id="element-71">{Math.abs(change)}%</span>
        </div>
        <span className="text-sm text-gray-500 ml-2" data-id="element-72">vs. mes anterior</span>
      </div>
    </div>;
};
export default KPICard;